define.alias("shared/components/shared/card/footer", "settings/components/shared/card/footer");